import React, { useEffect, useState } from "react"
import { Button, Col, Modal, ModalBody, Row } from "reactstrap"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../hooks/useResponse"
import SearchSelectBox from '../../../components/SearchSelectBox'
import {getAdmins} from '../../../api/admins'
import ResultHandler from "../../../components/ResultHandler"
import { assignEmployeeToAdmin } from "../../../api/employees"

const AssignAdminModal = ({handleClose, isOpen, employee, hnadleRefresh}) => {
  const { t } = useTranslation()

  const {loading, error, setData: setAssign} = useResponse(assignEmployeeToAdmin, () => {
    handleClose() 
    hnadleRefresh()
  })

  const [data, setData] = useState(null)

  useEffect(() => {
    if(employee?.admins?.length > 0){
      setData( employee.admins[0].id)
    }else{
      setData(null)
    }
  }, [employee])

  function handleSave(){

    setAssign({type: "add", data: {empId: employee.id, data: {admins: [data]}}})
  }

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered={true}>
      <ModalBody className="py-5 px-5">
        <Row>
          <Col lg={12}>
            <div className="text-center mb-4">
              <h2>Assign Admin</h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <SearchSelectBox 
              api={getAdmins}
              type='admins'
              label='username'
              setValue={(v) => setData(v.value)}
              
              value={data}
            />

            <ResultHandler error={error} />
          </Col>
          <Col>
            <div className="text-center mt-4">
              {!loading && <Button
                onClick={handleSave}
                color="primary"
                size="lg"
                style={{marginRight: "20px"}}
              >
                Save
              </Button>}
              {loading && <Button
                color="dark"
                size="lg"
                style={{marginRight: "20px"}}
              >
                Wait
              </Button>}
              <Button
                onClick={handleClose}
                color="dark"
                size="lg"
              >
                {t("btns.Cancel")}
              </Button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default AssignAdminModal
